/**
 * The number a basket badge is allowed to show (OE-149).
 *
 * The counts are maintained incrementally by a backend trigger, so a stored
 * value can be wrong — and a workspace poisoned before the trigger was fixed
 * can still hold a NEGATIVE number today. `count || 0` does not catch that:
 * `-13` is truthy, so it rendered straight onto the badge.
 *
 * The backend clamps at the source and a repair script heals stored drift; this
 * is the last line, so a bad number in the database can never be shown as a
 * nonsensical one on screen.
 */
export function displayBasketCount(count: unknown): number {
    if (typeof count !== 'number' || !Number.isFinite(count)) return 0;
    return Math.max(0, Math.trunc(count));
}
